import * as React from 'react';
import { useTranslation } from 'hooks';
import { Card, CardContent } from 'components/ui/card';
import { Button } from 'components/ui/ButtonGs';
import { Checkbox } from 'components/ui/checkbox';
import { Label } from 'components/ui/label';

import { translations } from './translations';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  onClickSubmit?: () => void;
  onClickCancel?: () => void;
  loading?: boolean;
}

export const CreateRouteSubmissionBar = ({ onClickSubmit, onClickCancel, loading, ...props }: Props) => {
  const { getTranslation: t } = useTranslation(translations);
  const [checked, setChecked] = React.useState<boolean | 'indeterminate'>(false);

  return (
    <Card {...props}>
      <CardContent className={'pt-6 flex flex-row gap-4'}>
        <div className={'flex flex-row items-center gap-4'}>
          <Checkbox id={'contract-agreement'} checked={checked} onCheckedChange={setChecked} />
          <Label htmlFor={'contract-agreement'} className={'text-gray-500 font-sans'}>
            Declaro, que as informações inseridas no sistema estão de acordo com o contrato estabelecido com a Kemira.
          </Label>
        </div>
        <div className={'flex flex-row items-center gap-4 flex-grow flex-shrink-0'}>
          <Button.Root
            onClick={onClickCancel}
            variant={'secondary'}
            size={'sm'}
            className={'ml-auto'}
            disabled={loading}
          >
            {t('cancelButton')}
          </Button.Root>
          <Button.Root
            onClick={onClickSubmit}
            variant={'primary'}
            size={'sm'}
            disabled={!checked || loading}
          >
            {t('submitButton')}
          </Button.Root>
        </div>
      </CardContent>
    </Card>
  );
};